export default __webpack_public_path__ + "static/media/3018.5127fe62.jpg";